import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { JwtPasteModal } from "./auth/JwtPasteModal";
import { IdentityCacheCleaner } from "./identity/IdentityCacheCleaner";
import { JobsAuthBridge } from "./jobs/JobsAuthBridge";
import { JobsCacheCleaner } from "./jobs/JobsCacheCleaner";
import { ProjectCacheCleaner } from "./project/ProjectCacheCleaner";
import { ProjectProvider } from "./project/ProjectContext";
import { Home } from "./routes/Home";
import { JobsRoute } from "./routes/Jobs";
import { RootLayout } from "./routes/RootLayout";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { retry: false, refetchOnWindowFocus: false },
    },
});

export function App() {
    return (
        <QueryClientProvider client={queryClient}>
            {/*
              IdentityCacheCleaner is mounted before ProjectCacheCleaner.
              Both subscribe to `auth:logout`. The PRD-003 DoD-mandated
              clearing order is JWT → identity → project → in-flight UI;
              subscribers fire in registration order, so this mount order
              encodes the contract.
            */}
            <IdentityCacheCleaner />
            <ProjectCacheCleaner />
            <JobsCacheCleaner />
            <AuthProvider>
                <JobsAuthBridge />
                <ProjectProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route element={<RootLayout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/jobs" element={<JobsRoute />} />
                            </Route>
                        </Routes>
                        <JwtPasteModal />
                    </BrowserRouter>
                </ProjectProvider>
            </AuthProvider>
        </QueryClientProvider>
    );
}
